import { gql } from '@apollo/client';
import { Form, Input } from 'antd';
import DrawerForm from 'components/DrawerForm';
import FormLabel from 'components/FormLabel';
import { useMutation } from 'hooks/apollo';
import React, { useMemo } from 'react';

import globalMessages from 'translations/messages';
import SurveyCategorySelect from 'components/SurveyCategorySelect';

import messages from '../../messages';

const UPDATE_SURVEY_GROUP = gql`
  mutation($id: ID!, $input: SurveyGroupInput!) {
    updateSurveyGroup(id: $id, input: $input) {
      id
    }
  }
`;

const EditSurveyGroup = ({ open, onCancel, onDone, survey }) => {
  const [updateSurveyGroup] = useMutation(UPDATE_SURVEY_GROUP);

  const initialValues = useMemo(() => ({
    title: survey.languageParent.title || survey.title,
    customerAlias: survey.customerAlias,
    categoryIds: survey.categories.map(({ id }) => id),
  }), [survey]);

  const onSubmit = (values) => updateSurveyGroup({ variables: { id: survey.languageParent.id, input: values } });

  return (
    <DrawerForm open={open} onCancel={onCancel} onDone={onDone} onSubmit={onSubmit} removeLabel={initialValues.title} title="Survey settings" initialValues={initialValues} formReset={survey}>
      <Form.Item
        name="title"
        label={<FormLabel label={globalMessages.title} />}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="customerAlias"
        label={<FormLabel label={messages.customerAlias} description={messages.customerAliasDescription} />}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="categoryIds"
        label={<FormLabel label={messages.industries} description={messages.industriesDescription} />}
      >
        <SurveyCategorySelect mode="multiple" />
      </Form.Item>
    </DrawerForm>
  );
};

export default EditSurveyGroup;
